// extracted by mini-css-extract-plugin
module.exports = {"dots":"Patterns_dots__1Tz0B","animatedIn":"Patterns_animatedIn___x9Fz","isPassiveDotPattern":"Patterns_isPassiveDotPattern__25FJI"};